import "./index.css";

const Content = ({ children }) => {
  return <section className="content-wrapper">{children}</section>;
};

export default Content;
